import { OpenapiElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Openapi extends OpenapiElement {}
export default Openapi;